import React, { useEffect } from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { Helmet } from 'react-helmet';
import Header from './components/Header';
import FormSection from './components/FormSection';
import CatalogSection from './components/CatalogSection';
import PartnersSection from './components/PartnersSection';
import ContactSection from './components/ContactSection';
import Footer from './components/Footer';
import CatalogPage from './components/CatalogPage';
import About from './components/About';
import DeliveryPage from './components/DeliveryPage';
import TestimonialsPage from './components/TestimonialsPage';
import PrivacyPolicyPage from './components/PrivacyPolicyPage';

const App = () => {
  useEffect(() => {
    const script = document.createElement('script');
    script.src = "//code.jivosite.com/widget/MrL0Qyr52w";
    script.async = true;
    document.body.appendChild(script);
    // При размонтировании удалить скрипт (хотя App обычно не размонтируется)
    return () => {
      document.body.removeChild(script);
    };
  }, []);

  return (
    <Router>
      <div className="min-h-screen flex flex-col bg-gray-100 text-gray-900 font-sans">
        <Header />
        <Routes>
          <Route
            path="/"
            element={
              <>
                <Helmet>
                  <title>Металлопрокат и арматура – МЕТАЛЛ ИВАНЫЧ</title>
                  <meta
                    name="description"
                    content="Продажа металлопроката и арматуры в Москве от компании МЕТАЛЛ ИВАНЫЧ. Выгодные цены, качественная продукция, доставка по Москве и области."
                  />
                </Helmet>
                <FormSection />
                <CatalogSection />
                <PartnersSection />
                <ContactSection />
              </>
            }
          />
          <Route
            path="/catalog"
            element={
              <>
                <Helmet>
                  <title>Каталог металлопроката – МЕТАЛЛ ИВАНЫЧ</title>
                  <meta
                    name="description"
                    content="Широкий ассортимент металлопроката и арматуры от МЕТАЛЛ ИВАНЫЧ. Ознакомьтесь с каталогом и сделайте заказ."
                  />
                </Helmet>
                <CatalogPage />
              </>
            }
          />
          <Route
            path="/contacts"
            element={
              <>
                <Helmet>
                  <title>Контакты – МЕТАЛЛ ИВАНЫЧ</title>
                  <meta name="description" content="Свяжитесь с компанией МЕТАЛЛ ИВАНЫЧ для заказа металлопроката и арматуры." />
                </Helmet>
                <ContactSection />
              </>
            }
          />
          <Route
            path="/about"
            element={
              <>
                <Helmet>
                  <title>О компании – МЕТАЛЛ ИВАНЫЧ</title>
                  <meta name="description" content="Информация о компании МЕТАЛЛ ИВАНЫЧ, наших услугах и преимуществах." />
                </Helmet>
                <About />
              </>
            }
          />
          <Route
            path="/delivery-payment"
            element={
              <>
                <Helmet>
                  <title>Доставка и оплата – МЕТАЛЛ ИВАНЫЧ</title>
                  <meta name="description" content="Условия доставки и оплаты металлопроката от МЕТАЛЛ ИВАНЫЧ." />
                </Helmet>
                <DeliveryPage />
              </>
            }
          />
          <Route
            path="/testimonials"
            element={
              <>
                <Helmet>
                  <title>Отзывы клиентов – МЕТАЛЛ ИВАНЫЧ</title>
                  <meta name="description" content="Отзывы наших клиентов о работе с МЕТАЛЛ ИВАНЫЧ." />
                </Helmet>
                <TestimonialsPage />
              </>
            }
          />
          <Route
            path="/privacy"
            element={
              <>
                <Helmet>
                  <title>Политика конфиденциальности – МЕТАЛЛ ИВАНЫЧ</title>
                  <meta name="description" content="Политика конфиденциальности сайта МЕТАЛЛ ИВАНЫЧ." />
                </Helmet>
                <PrivacyPolicyPage />
              </>
            }
          />
        </Routes>
        <Footer />
      </div>
    </Router>
  );
};

export default App;
